<template lang="pug">
  .d-flex.justify-space-between.align-center
    template(v-for="stamp in totalStamp")
      template(v-if="stamp <= stampCollected")
        loyalty-stamp-gift(v-if="isRewardIcon(stamp)" isSuccess)
        loyalty-stamp-dot(v-else isSuccess)
      template(v-else)
        loyalty-stamp-gift(v-if="isRewardIcon(stamp)")
        loyalty-stamp-dot(v-else)
</template>

<script>
import LoyaltyStampGift from "@/components/marketing/merchantapp/stamps/LoyaltyStampGift.vue";
import LoyaltyStampDot from "@/components/marketing/merchantapp/stamps/LoyaltyStampDot.vue";

export default {
  components: {
    LoyaltyStampDot, LoyaltyStampGift,
  },
  props: {
    stampCollected: {
      type: Number,
      default: 0
    },
    rewardsPosition: {
      type: Array,
      default: () => ([])
    },
  },
  data() {
    return {
      totalStamp: 10
    }
  },
  methods: {
    isRewardIcon(position) {
      return this.rewardsPosition.includes(position)
    }
  },
}
</script>


<style scoped>

</style>